export default __webpack_public_path__ + "static/media/britain_icon.9775f62f.png";